export default {"src":"/_next/static/media/business7.b9a92de9.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};